import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let END_POINT

if (window.location.protocol === 'http:') {
    END_POINT = `http://localhost:5001`
}
else {
    END_POINT = `https://${window.location.host}/api`
}

// jwtToken
const getJwtToken = () => {
    const userData = JSON.parse(localStorage.getItem("clinic-application-jwt"));
    return "Bearer " + String(userData.token);
};


export const ShareLinksByEmail = createAsyncThunk(
  "ShareLinks/ShareLinksByEmail",
  async ({email,link}, { rejectWithValue }) => {
    console.log("Sharing link via email:", { email, link });
    try {
      const res = await axios.post(`${END_POINT}/shareLink/Gmail`, {
        email,
        link
      }, {
        headers: {
          Authorization: getJwtToken()
        }
      });
      return res.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return []; // ✅ No items, return empty array instead of rejecting
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const ShareRouteLinkByEmail = createAsyncThunk(
  "ShareRouteLinks/ShareLinksByEmail",
  async ({email,filePath}, { rejectWithValue }) => {
    console.log("Sharing link via email:", { email,filePath });
    try {
      const res = await axios.post(`${END_POINT}/shareLink/sendroute`, {
        email,
        filePath
      }, {
        headers: {
          Authorization: getJwtToken()
        }
      });
      return res.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return []; // ✅ No items, return empty array instead of rejecting
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);